import React from 'react';
import { connect } from "react-redux";
import { ConfigProvider } from 'antd';

import DocumentTitle from 'react-document-title';
import localeIntl from "./intl/data.json";
import { IntlProvider } from "react-intl";
import { BrowserRouter as Router, Route } from 'react-router-dom';

import './assets/css/antd.scss';
import './assets/css/animate.css';
import './assets/css/responsive.scss';

import * as authAct from "./store/auth/_authActions";
import * as utilsAct from "./store/utils/_utilsActions";

import AuthContainer from "./screens/AuthContainer/AuthContainer";

const App = (props) => {
  const { _utils: { lang, pageTitle } } = props;
  const path = window.location.pathname.split('/');
  if (path[2] === 'signout') {
    const params = new URLSearchParams(window.location.search);
    const continueUrl = params.get('continue') || undefined;
    props.signOut(continueUrl);
  }

  return (
    <ConfigProvider theme={{
      token: {
        colorPrimary: '#0D3B77',
        colorLink: '#044c80',
        colorLinkHover: '#044c80',
        colorLinkActive: '#044c80',
        borderRadius: 4,
        borderRadiusLG: 4,
        borderRadiusSM: 4,
        colorBorder: '#E9E9E9',
        colorBorderSecondary: '#E9E9E9',
        colorText: '#505050',
        fontSize: 14,
      },
      components: {
        Form: {
          labelColor: '#505050',
          labelFontSize: 14,
          verticalLabelPadding: '0 0 4px',
          itemMarginBottom: 12,
        },
        Input: {
          borderRadius: 4,
          colorBorder: '#E9E9E9',
          hoverBorderColor: '#044c80',
          activeBorderColor: '#044c80',
          activeShadow: '0 0 0 2px rgba(28, 78, 114, 0.2)',
        },
        Select: {
          borderRadius: 4,
          colorBorder: '#E9E9E9',
        },
        Button: {
          borderRadius: 4,
          colorPrimary: '#044c80',
          colorPrimaryHover: '#033d6a',
          colorPrimaryActive: '#033d6a',
          primaryShadow: 'none',
        },
        Modal: {
          borderRadius: 4,
        },
      }
    }}>
      <DocumentTitle title={pageTitle}>
        {path[2] !== 'signout' && (
          <IntlProvider locale={lang} messages={localeIntl[lang]}>
            <Router>
              <Route render={() => <AuthContainer {...props} />} />
            </Router>
          </IntlProvider>
        )}
      </DocumentTitle>
    </ConfigProvider>
  );
};

const mapStateToProps = (state) => ({
  _auth: state.auth,
  _utils: state.utils,
  router: state.router
});

const mapDispatchToProps = (dispatch) => ({
  setAccount: (data) => {
    dispatch(authAct.setAccount(data))
  },
  signOut: () => {
    dispatch(authAct.signOut())
  },
  signIn: (int, lang, data, onOK) => {
    dispatch(authAct.signIn(int, lang, data, onOK))
  },
  signUp: (int, lang, data) => {
    dispatch(authAct.signUp(int, lang, data))
  },
  setLoginStorage: (user, account) => {
    dispatch(authAct.setLoginStorage(user, account))
  },
  setLang: (lang) => {
    dispatch(utilsAct.setLang(lang))
  },
  setInvCookie: (key, value) => {
    dispatch(utilsAct.setInvCookie(key, value))
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
